<template>
  <div class="container">
    <div id="login">
      <div class="login-box">
        <div class="login-logo">
          <img :src="theme.getLoginIcon()" id="main-logo" alt=""/>
        </div>
        <!-- /.login-logo -->
        <div class="card">
          <div class="card-header">
            <i class="fas fa-shield-alt text-gray"></i>
            Login
          </div>

          <div class="card-body login-card-body">
            <div v-if="errors" class="alert alert-danger" role="alert">
              {{ errors }}
            </div>
            <p class="login-box-msg">Effettua l'accesso</p>
            <form @submit.prevent="login()">
              <div class="input-group mb-3">
                <input type="text" class="form-control" v-model="username" placeholder="Username"/>
                <div class="input-group-append">
                  <div class="input-group-text">
                    <span class="fas fa-user"></span>
                  </div>
                </div>
              </div>
              <div class="input-group mb-3">
                <input type="password" class="form-control" v-model="password" placeholder="Password"/>
                <div class="input-group-append">
                  <div class="input-group-text">
                    <span class="fas fa-lock"></span>
                  </div>
                </div>
              </div>

              <div class="login-btn-row">
                <button :disabled="loading" type="submit" class="btn btn-primary">
                  Accedi
                  <span v-if="loading" class="spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span>
                </button>
                
                <!-- oauth -->
                <a v-if="showSSO" :href="`${apiUrl}/auth/azure/redirect`" target="_blank" rel="noopener noreferrer">
                  <button :disabled="loading" type="button" class="btn btn-primary btn-block">
                    Accedi con Microsoft
                  </button>
                </a>
                
                <!-- saml sso -->
                <a v-if="showSAMLSSO" :href="`${apiUrl}/auth/sso/login`">
                  <button :disabled="loading" type="button" class="btn btn-primary btn-block">
                    Accedi con SSO
                  </button>
                </a>
              </div>
            </form>


            <p class="my-2">
              <router-link to="/password/forgot">Password dimenticata</router-link>
            </p>
          </div>
          <!-- /.login-card-body -->
        </div>
      </div>
      <!-- /.login-box -->
    </div>
  </div>
</template>

<script setup>
import { ref, inject } from "vue";
import {useRoute, useRouter} from "vue-router";
import useAuthStore from "@/stores/auth.store.js";
import useThemeStore from "@/stores/theme.store.js";
import axios from "@/services/axios.setup.js"
import { errorToast } from "@/services/toast.service";

const apiUrl = import.meta.env.VITE_API_URL;
const showSSO = import.meta.env.VITE_SSO_ENABLED == 'true';
const showSAMLSSO = import.meta.env.VITE_SAML_ENABLED == 'true';
const authStore = useAuthStore();
const router = useRouter();
const route = useRoute();
const theme = useThemeStore();
const tryAsync = inject('tryAsync');

const loading = ref(false);
const errors = ref(null);
const username = ref('');
const password = ref('');

async function login() {
  loading.value = true;

  const { data } = await tryAsync(
    axios.post('/login', {
      username: username.value,
      password: password.value
    }),
    "Errore nel login",
    () => loading.value = false
  );

  if (data.needs_reset) {
    router.push('password/reset/' + data.password_reset_token)
  } else if (data.result === 'success') {
    authStore.setUser(data);
    router.push('/');
  } else {
    errorToast(data.message);
    password.value = ""
  }
}

async function init() {
  let code = route.query.code ?? null
  let error = route.query.error ?? null

  if (error) {
    errorToast(error);
  } else if (code) {
    loading.value = true;
    
    const { data } = await tryAsync(
      axios.post('/auth/sso/token', { code }),
      "Errore nel richiedere il token di login",
      () => loading.value = false
    );

    if (data.result === 'success') {
      authStore.setUser(data);
      router.push('/');
    } else {
      errorToast(data.message);
      password.value = ""
    }
  }
}

init();
</script>

<style>

.login-btn-row {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.login-btn-row > * {
  flex-grow: 0;
}
</style>
